import { int } from "@goodgamestudios/math-utilities";
import { BonusVO } from "../../gamevo/BonusVO";

export class BonusVOParseHelper {
    // parse structure: %xt%gdb%1%0%{"day":2,"L":[[1200,0,0],[1800,1200,0],[2400,1800,0],[3000,0,1]]}%
    public static parseBonusVOs(paramObj: any): BonusVO[] {
        if (!paramObj.L) {
            return null;
        }

        var bonusVOs: BonusVO[] = [];

        var i: number = 0;
        var len: number = int(paramObj.L.length);
        var tempDay: any[];
        var bonusVO: BonusVO;
        for (i = 0; i < len; ++i) {
            tempDay = paramObj.L[i];

            // chips, xp, gold
            bonusVO = new BonusVO(tempDay[0], tempDay[1], tempDay[2]);
            bonusVOs.push(bonusVO);
        }

        return bonusVOs;
    }
}
